import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270bf982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add payment status info", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48dGl0bGUvPjxnIGlkPSJjcm9zcyI+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iNyIgeDI9IjI1IiB5MT0iNyIgeTI9IjI1Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iNyIgeDI9IjI1IiB5MT0iMjUiIHkyPSI3Ii8+PC9nPjwvc3ZnPg==" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row mt-1" }
const _hoisted_11 = { class: "col-6 text-end" }
const _hoisted_12 = { class: "col-6 text-start" }
const _hoisted_13 = {
  key: 0,
  class: "disabled-description"
}
const _hoisted_14 = {
  key: 0,
  class: "content-body"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row mt-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Payment date:", -1))
const _hoisted_18 = { class: "col-8 text-start" }
const _hoisted_19 = { class: "row mt-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Payment method:", -1))
const _hoisted_21 = { class: "col-8 text-start" }
const _hoisted_22 = { class: "content-body" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "row mt-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Your name:", -1))
const _hoisted_26 = { class: "col-8 text-start" }
const _hoisted_27 = { class: "row mt-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Note:", -1))
const _hoisted_29 = { class: "col-8 text-start" }
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Apply ")
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radiobutton = _resolveComponent("radiobutton")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_dropdownlist = _resolveComponent("dropdownlist")!
  const _component_formtextarea = _resolveComponent("formtextarea")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.showPopup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", {
                    class: "close-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_radiobutton, {
                              name: 'group1',
                              value: 1,
                              size: 'large',
                              checked: !_ctx.model.paidByInvoice,
                              label: 'Manual Paid',
                              onChange: _ctx.handlePaidTypeChange
                            }, null, 8, ["checked", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_radiobutton, {
                              name: 'group1',
                              value: 2,
                              size: 'large',
                              checked: _ctx.model.paidByInvoice,
                              label: 'For invoicing',
                              disabled: !_ctx.allowsInvoicing,
                              onChange: _ctx.handlePaidTypeChange
                            }, null, 8, ["checked", "disabled", "onChange"]),
                            (!_ctx.allowsInvoicing)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "In order to select this client must be approved by a director "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    (!_ctx.model.paidByInvoice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_datepicker, {
                                  style: { width: '300px' },
                                  "default-value": _ctx.paymentDefaultDate,
                                  value: _ctx.model.paymentDate,
                                  max: new Date(),
                                  onChange: _ctx.handlePaymentDateChange
                                }, null, 8, ["default-value", "value", "max", "onChange"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_dropdownlist, {
                                  style: { width: '300px' },
                                  "data-items": _ctx.paymentMethods,
                                  "default-item": {
                          Name: 'choose',
                        },
                                  "text-field": 'Name',
                                  "data-item-key": 'Id',
                                  value: _ctx.model.manualPaymentMethod,
                                  onChange: _ctx.handlePaymentMethodChange
                                }, null, 8, ["data-items", "value", "onChange"])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_dropdownlist, {
                              style: { width: '300px' },
                              "data-items": _ctx.users,
                              "default-item": {
                          Name: 'choose',
                        },
                              "text-field": 'Name',
                              "data-item-key": 'Id',
                              value: _ctx.model.user,
                              onChange: _ctx.handleUserChange
                            }, null, 8, ["data-items", "value", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_formtextarea, {
                              value: _ctx.model.note,
                              rows: 2,
                              onChange: _ctx.handleNoteChange
                            }, null, 8, ["value", "onChange"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-danger margin-right",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                      }, " Cancel "),
                      _createElementVNode("button", {
                        disabled: !_ctx.isFormValid || _ctx.isSaving,
                        class: "btn btn-success",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onYesButtonClick && _ctx.onYesButtonClick(...args)))
                      }, [
                        _hoisted_32,
                        (_ctx.isSaving)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_31)
                    ])
                  ], true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}